import { useSeoMeta } from "@unhead/react";
import { Link } from "react-router-dom";
import { SiteLayout } from "@/components/SiteLayout";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  useSeoMeta({
    title: "404 — JSBat",
    description: "The page you are looking for could not be found.",
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-24 text-center">
        <p className="font-mono text-lg text-muted-foreground">ReferenceError: page is not defined</p>
        <h1 className="mt-4 text-5xl font-extrabold tracking-tight">404</h1>
        <Button asChild className="mt-8 bg-brand text-brand-foreground hover:bg-brand/90">
          <Link to="/">Back to problems</Link>
        </Button>
      </div>
    </SiteLayout>
  );
};

export default NotFound;
